export default __webpack_public_path__ + "static/media/sidebar-2.a076623a.jpg";